import { RecordStatus } from '../../core/public_api';
import { LabelType } from '../../elements/public_api';

export class StatusMapper {
    public static getRecordStatusLabelType(
        status: RecordStatus,
        hasFailedJobs?: boolean,
        hasErrors?: boolean
    ): LabelType {
        if (hasFailedJobs || hasErrors) {
            return LabelType.Error;
        }

        const labelMapping: Record<RecordStatus, LabelType> = {
            // Concept
            [RecordStatus.Processing]: LabelType.Update,
            [RecordStatus.Uploaded]: LabelType.Update,
            [RecordStatus.Uploading]: LabelType.Update,
            [RecordStatus.New]: LabelType.Default,
            [RecordStatus.DraftValid]: LabelType.Success,
            [RecordStatus.DraftInvalid]: LabelType.Warning,
            [RecordStatus.Submitted]: LabelType.Warning,
            [RecordStatus.Rejected]: LabelType.Error,
            [RecordStatus.RejectedForCorrection]: LabelType.Warning,
            // Published
            [RecordStatus.Published]: LabelType.Success,
            [RecordStatus.Destructed]: LabelType.Success,
            [RecordStatus.ApprovedForDestruction]: LabelType.Default,
            [RecordStatus.Transferred]: LabelType.Success,
            [RecordStatus.ApprovedForTransfer]: LabelType.Default,
            // Archived
            [RecordStatus.Archived]: LabelType.Success,
            // Other
            [RecordStatus.Deleted]: LabelType.Default
        };

        return labelMapping[status] ?? LabelType.Default;
    }
}
